import styled from 'styled-components';
import { Table } from 'antd';
import { media } from '@/styles/Qtheme';

export const Wrapper = styled.div`
  background: rgba(0, 110, 73, 0.08);
  border-radius: 30px;
  overflow: hidden;
  width: 100%;
  box-sizing: border-box;
  padding: 48px 44px;

  @media ${media.mobile} {
    background: transparent;
    padding: 0;
    border-radius: 0;
  }
`;

// 데스크탑 테이블 래퍼
export const DesktopTableWrapper = styled.div`
  display: block;

  @media ${media.mobile} {
    display: none;
  }
`;

// 모바일 카드 리스트 래퍼
export const MobileCardList = styled.div`
  display: none;

  @media ${media.mobile} {
    display: flex;
    flex-direction: column;
    gap: 12px;
    width: 100%;
  }
`;

// 개별 카드
export const Card = styled.div`
  background: #0c2323;
  border-radius: 16px;
  overflow: hidden;
  padding: 6px 0;
  display: flex;
  flex-direction: column;
  gap: 2px;
`;

// 카드 헤더 (Tier 타이틀)
export const CardHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
  height: 32px;
  box-sizing: border-box;
`;

export const CardTitle = styled.p`
  font-family: 'NanumSquareRound', sans-serif;
  font-weight: 700;
  font-size: 14px;
  letter-spacing: -0.02em;
  color: #ffffff;
  margin: 0;
`;

// 카드 구분선
export const CardDivider = styled.div`
  width: 100%;
  height: 1px;
  background: linear-gradient(
    90deg,
    rgba(255, 255, 255, 0) 0%,
    rgba(255, 255, 255, 0.1) 50%,
    rgba(255, 255, 255, 0) 100%
  );
`;

// 카드 내용 영역
export const CardContent = styled.div`
  display: flex;
  flex-direction: column;
`;

// 카드 행
export const CardRow = styled.div`
  display: flex;
  align-items: center;
  padding: 10px 16px;
`;

// 두 항목이 나란히 있는 행
export const CardRowDouble = styled.div`
  display: flex;
  align-items: center;
  gap: 60px;
  padding: 10px 16px;
`;

// 카드 항목 (레이블 + 값)
export const CardItem = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const CardLabel = styled.p`
  font-family: 'NanumSquareRound', sans-serif;
  font-weight: 400;
  font-size: 12px;
  letter-spacing: -0.02em;
  color: #777986;
  margin: 0;
  white-space: nowrap;
`;

export const CardValue = styled.p`
  font-family: 'NanumSquareRound', sans-serif;
  font-weight: 400;
  font-size: 14px;
  letter-spacing: -0.02em;
  color: #e9e9ed;
  margin: 0;
`;

export const StyledTable = styled(Table)`
  .ant-table {
    background: transparent;
  }

  .ant-table-thead > tr > th {
    background: transparent;
    color: #777986;
    font-family: 'NanumSquareRound', sans-serif;
    font-weight: 400;
    font-size: 16px;
    letter-spacing: -0.02em;
    padding: 4px 24px 23px 24px;
    text-align: left;
    white-space: nowrap;

    &::before {
      display: none;
    }
  }

  .ant-table-tbody > tr > td {
    background: transparent;
    border-bottom: none;
    font-family: 'NanumSquareRound', sans-serif;
    font-weight: 400;
    font-size: 18px;
    letter-spacing: -0.02em;
    color: #ffffff;
    padding: 18px 24px;
    text-align: left;
  }

  .ant-table-tbody > tr {
    &:hover > td {
      background: rgba(255, 255, 255, 0.05) !important;
    }

    &:hover > td:first-child {
      border-radius: 12px 0 0 12px;
    }

    &:hover > td:last-child {
      border-radius: 0 12px 12px 0;
    }
  }

  .ant-table-container {
    border: none;
  }

  .ant-table-content {
    overflow-x: hidden;
  }
` as typeof Table;

export const Cell = styled.span<{ $color?: string }>`
  color: ${({ $color }) => $color || '#ffffff'};
  font-family: 'NanumSquareRound', sans-serif;
  font-weight: 400;
  font-size: 18px;
  letter-spacing: -0.02em;
  white-space: nowrap;
`;
